class WishlistListMember extends window.BAO.CustomElement() {
  setupListeners () {
    super.setupListeners()

    this.actioned = false

    this.onRemoveClicked = this.onRemoveClicked.bind(this)
    this.listeners.add(this.els.remove.element, 'click', this.onRemoveClicked)
  }

  async onRemoveClicked (event) {
    event.preventDefault()

    if (this.actioned) return
    this.actioned = true

    this.setBusy(true)
    this.hideError()

    let apiResult

    try {
      apiResult = await window.BAO.wishlist.removeMember(
        this.listId,
        this.collaboratorId,
        this.access,
      )
    } catch {
      /* postCollaborator throws on any non-2xx, and `actioned` was the only
         thing between a failed remove and a button that never worked again:
         the row sat there looking removable and did nothing (Dan, 08.09).
         The row stays, the button comes back, and the reason is on screen. */
      this.actioned = false
      this.setBusy(false)
      this.showError()

      return
    }

    this.setBusy(false)

    // Members of either access level keep the summary row and modal open;
    // the patched strings themselves count edit members only (#95).
    this.externalEls.collaborators.element.setAttribute(
      'aria-hidden',
      apiResult.members > 0 ? 'false' : 'true',
    )
    this.externalEls.collaboratorsText.element.innerHTML =
      apiResult.collaborators_html
    this.externalEls.membersDescription.element.innerHTML =
      apiResult.members_description_html

    this.remove()

    /* Revoking is editing access too, and the chat drawer can be open behind
       this modal with no reload between them (Dan, 07.09, #390): without
       this it would keep the shared guidance and the "Visible only to people
       on this shared list" caption on a list that nobody can reach any more.
       Same event the share surfaces fire after a grant. */
    document.body.dispatchEvent(
      new CustomEvent('wishlist:access-changed', {
        bubbles: true,
        detail: {
          listId: this.listId,
          edit_collaborator_count: apiResult.members,
        },
      }),
    )

    if (apiResult.members === 0) {
      document.body.dispatchEvent(
        new CustomEvent('site-modal:close', {
          bubbles: true,
          detail: { id: 'wishlist-list-manage' },
        }),
      )
    }
  }

  /* Disabled alone reads as "unavailable". The button also goes aria-busy
     and swaps to the busy label the page rendered through `t` — the shape
     the chat composer's send button uses. The label is its own span, so the
     swap leaves the close glyph beside it alone. */
  setBusy (busy) {
    const button = this.els.remove.element
    const label = busy ? button.dataset.busyLabel : button.dataset.restingLabel

    button.disabled = busy

    if (busy) {
      button.setAttribute('aria-busy', 'true')
    } else {
      button.removeAttribute('aria-busy')
    }

    if (label && this.els.removeLabel) {
      this.els.removeLabel.element.textContent = label
    }
  }

  /* The sentence is server-rendered and hidden; this only reveals it, so no
     copy is written in this file. */
  showError () {
    if (this.els.error) this.els.error.element.hidden = false
  }

  hideError () {
    if (this.els.error) this.els.error.element.hidden = true
  }

  get listId () {
    return this.dataset.listId
  }

  get collaboratorId () {
    return this.dataset.collaboratorId
  }

  get access () {
    return this.dataset.access
  }
}

if (!window.customElements.get('wishlist-list-member')) {
  window.customElements.define('wishlist-list-member', WishlistListMember)
}
